import React from "react";

import { css } from "@emotion/core";
import { kebabCase } from "lodash";
import { useEffect, useState } from "react";
import { Colors, useTheme } from "@zapier/design-system";
import buildStaticAssetUrl from "@zapier/payment/esm/utils/buildStaticAssetUrl";
import { breakpoints } from "@zapier/payment/esm/constants";

const imageCss = (isSmall: boolean) => ({
  display: "inline-block",
  width: isSmall ? 50 : 60,
});

const svgCss = (props: PaymentMethodImageProps) => ({
  display: "block",
  height: "inherit",
  opacity: props.isDisabled ? 0.4 : 1.0,
  width: "inherit",
});

/* Rebrand styles */
const rebrandImageCss = css`
  display: inline-block;
  width: 63px;

  @media screen and (max-width: ${breakpoints.mobileMax}px) {
    width: 43px;
  }
`;

const rebrandSvgCss = css`
  border: 1px solid ${Colors.neutral400};
  border-radius: 4px;
`;

type PaymentMethodImageProps = {
  /** Image type to show */
  imageType?: string | null;
  /** Show image greyed out */
  isDisabled?: boolean;
  /** Show small version of image */
  isSmall?: boolean;
};

const PaymentMethodImage = (props: PaymentMethodImageProps) => {
  const { isRebrand } = useTheme();
  const [imageNotFound, setImageNotFound] = useState(false);
  const { imageType, isSmall = false } = props;

  // Sets the image not found flag back to false if imageType changes
  useEffect(() => {
    setImageNotFound(false);
  }, [imageType]);

  const svgUrl =
    !imageType || imageNotFound
      ? buildStaticAssetUrl("/images/payment/unknown.svg")
      : buildStaticAssetUrl(`/images/payment/${kebabCase(imageType)}.svg`);

  const rebrandSvgUrl =
    !imageType || imageNotFound
      ? buildStaticAssetUrl("/images/payment/logos/unknown.svg")
      : buildStaticAssetUrl(
          `/images/payment/logos/${kebabCase(imageType)}.svg`
        );

  return (
    <span css={isRebrand ? rebrandImageCss : imageCss(isSmall)}>
      <img
        alt={imageType ?? "Payment Method Image Placeholder"}
        css={[svgCss(props), isRebrand && rebrandSvgCss]}
        onError={() => setImageNotFound(true)}
        src={isRebrand ? rebrandSvgUrl : svgUrl}
      />
    </span>
  );
};

export default PaymentMethodImage;
